// extracted by mini-css-extract-plugin
export default {"container":"AboutOurCompany_container__H8FcQ","textcontainer":"AboutOurCompany_textcontainer__g48G3"};